<template>
  <div class="relative inline-block group">
    <span class="text-stone-400 dark:text-stone-500 cursor-help">
      <i class="fas fa-question-circle"></i>
    </span>
    <div class="tooltip-content invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 absolute z-20 bottom-full left-1/2 transform -translate-x-1/2 -translate-y-2 w-64 p-2 bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 text-sm rounded-md shadow-lg border border-stone-200 dark:border-stone-600 whitespace-normal">
      {{ title }}
      <div class="tooltip-arrow absolute top-full left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white dark:bg-stone-700 rotate-45 border-r border-b border-stone-200 dark:border-stone-600"></div>
    </div>
  </div>
</template>

<script setup>
defineProps({ title: String });
</script>

<style scoped>
  /* The tooltip content should be above the arrow */
  .tooltip-content {
    z-index: 10;
  }
  
  /* The arrow should be below the content */
  .tooltip-arrow {
    z-index: 9;
  }
</style>
